<div class="faq-autopay">
  <div class="faq-sub-question-title">Other questions</div>
  <section [multiple]="false">
    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" (click)="closeNonActiveCollapse('one')" mdbRipple [class.active]="accordianWithMDB.one">
        <div class="faq-item">
          <div class="faq-item-title">Who is Mapfre? </div>
          <div class="faq-arrow-block">
            <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.one" alt="simple down arrow" />
            <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.one" alt="simple up arrow" />
          </div>
        </div>
      </a>
      <div class="padding-left pl16" #one [class.fake-accourdian]="!accordianWithMDB.one">
        <div class="faq-answ-block">
         <div> At Mapfre Insurance, providing peace of mind starts with personal service from more than 2,000 dedicated professionals, all focused on protecting what matters most to you and your family. Here's a closer look at who we are:</div><br>
          <div class="fw-700">Global presence: Mapfre around the world</div>
         <div> Proudly part of the Mapfre Group, we are a leading global insurance organization with a presence on five continents, serving:</div><br>
          <ul class="mb-0 faq-ul">
            <li>31 million customers worldwide.</li>
            <li>Backed by a team of 31,000 professionals dedicated to excellence.</li>
          </ul><br>
          <div>Learn more at <a class="mapfre link red-link fw-400-imp faq-text-decoration" href="https://mapfreinsurance.com" target="_blank" rel="noopener">mapfreinsurance.com</a>.</div><br>
          <div class="fw-700">Local focus: Mapfre in the United States</div>
          <ul class="mb-0 faq-ul">
            <li>A wide range of insurance solutions for auto, home, and more.</li>
            <li>Among the top personal lines insurers in the U.S.</li>
            <li>Serving policyholders across multiple states, with a strong Northeast presence.</li>
            <li>Working with a trusted network of independent agents and brokers.</li>
            <li>Financial Strength: Rated A (Excellent) by A.M. Best.</li>
          </ul><br>
          <div class="fw-700">Global expertise. Local care. That’s the Mapfre feeling.</div>
        </div>
      </div>
    </div>

    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" (click)="closeNonActiveCollapse('two')" mdbRipple [class.active]="accordianWithMDB.two">
        <div class="faq-item">
          <div class="faq-item-title">What products does Mapfre offer? </div>
          <div class="faq-arrow-block">
            <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.two" alt="simple down arrow" />
            <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.two" alt="simple up arrow" />
            </div>
          </div>
      </a>
      <div class="padding-left pl16" #two  [class.fake-accourdian]="!accordianWithMDB.two">
        <div class="faq-answ-block">{{ 'INFORMATION_PRODUCTS_1' | translate }}
          <div>{{ 'INFORMATION_PRODUCTS_2' | translate }}</div><br>
          <div>
            <ul class="mb-0 faq-ul">
              <li>Personal and commercial auto.</li>
              <li>Get a quote.</li>
              <li>Personal and commercial property.</li>
              <li>Motorcycle.</li>
              <li>Business.</li>
              <li>Umbrella.</li>
              <li>Recreational vehicle.</li>
              <li>Watercraft.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" (click)=" closeNonActiveCollapse('three')" mdbRipple [class.active]="accordianWithMDB.three">
        <div class="faq-item">
          <div class="faq-item-title">What Discounts does Mapfre have?</div>
          <div class="faq-arrow-block">
            <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.three" alt="simple down arrow" />
            <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.three" alt="simple up arrow" />
          </div>
        </div>
      </a>
      <div class="padding-left pl16" #three [class.fake-accourdian]="!accordianWithMDB.three">
        <div class="faq-answ-block">
          <div>Mapfre Insurance offers a multitude of discounts to ensure that you’re getting the most value out of your policy. Personal auto and personal property discounts include:</div><br>
          <ul class="mb-0 faq-ul">
            <li class="pl12">Discount for bundling insurance for your auto and home through Mapfre.</li>
            <li class="pl12">Paid-in-Full discount.</li>
            <li class="pl12">Good Student discount.</li>
            <li class="pl12">Student away from home discount.</li>
            <li class="pl12">Annual Mileage discount.</li>
            <li class="pl12">Multi-Car discount.</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" href="https://www.mapfreinsurance.com/en/terms-conditions/" target="_blank" 
        rel="noopener" mdbRipple [class.active]="accordianWithMDB.four"
      >
        <div class="faq-item">
          <div class="faq-item-title">Mapfre’s Legal Terms and Conditions</div>
          <div class="faq-arrow-block">
            <img src="assets/img/images/faq-arrow-right.svg" *ngIf="!accordianWithMDB.four" alt="simple down arrow" />
            <img src="assets/img/images/faq-arrow-right.svg" *ngIf="accordianWithMDB.four" alt="simple up arrow" />
          </div>
        </div>
      </a>
      <div class="padding-left pl16"  #four [class.fake-accourdian]="!accordianWithMDB.four">
        <div class="faq-answ-block"></div>
      </div>
    </div>
  </section>

<div class="row margin-top mt24 text-center">
    <div class="col">
      <a routerLink="/faq" class="faq-back"><img src="assets/img/images/faq-icon-strong-arrow-left.svg" class="align-middle pr-1"><p class="faq-back-btn">{{ 'BACK' | translate }}</p></a>
    </div>
  </div>
</div>
